import { useEffect } from "react";
import {
  RealtimeKitProvider,
  useRealtimeKitClient,
  useRealtimeKitMeeting,
  useRealtimeKitSelector,
} from "@cloudflare/realtimekit-react";
import { RtkMeeting } from "@cloudflare/realtimekit-react-ui";
import { MeetingLogoutButton } from "./MeetingLogoutButton";
import type { MeetingSessionExperienceProps } from "./meetingProductTypes";

function WebinarMeetingUi({
  showLogout,
  loggingOut,
  onLogout,
}: {
  showLogout: boolean;
  loggingOut: boolean;
  onLogout: () => void;
}) {
  const { meeting } = useRealtimeKitMeeting();
  const roomState = useRealtimeKitSelector((m) => m.self.roomState);
  const showLogoutButton = showLogout && roomState !== "joined";

  if (!meeting) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-black text-white">
        Connecting...
      </div>
    );
  }

  return (
    <div className="relative h-dvh w-screen bg-black">
      {showLogoutButton ? (
        <MeetingLogoutButton
          showLogout={showLogoutButton}
          loggingOut={loggingOut}
          onLogout={onLogout}
        />
      ) : null}
      <RtkMeeting meeting={meeting} mode="fill" showSetupScreen />
    </div>
  );
}

function WebinarMeetingExperienceInner({
  authToken,
  showLogout,
  loggingOut,
  onLogout,
}: MeetingSessionExperienceProps) {
  const [meetingClient, initMeeting] = useRealtimeKitClient();

  useEffect(() => {
    initMeeting({ authToken });
  }, [authToken, initMeeting]);

  return (
    <RealtimeKitProvider value={meetingClient}>
      <WebinarMeetingUi
        showLogout={showLogout}
        loggingOut={loggingOut}
        onLogout={onLogout}
      />
    </RealtimeKitProvider>
  );
}

export function WebinarMeetingExperience(props: MeetingSessionExperienceProps) {
  return <WebinarMeetingExperienceInner {...props} />;
}
